var _rect, _rect2, _circle, _path, _ellipse, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypeOmissionWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#C2C2C2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 10,
    fill: "#FFC300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0182 14.0296C21.9947 13.9779 21.4255 12.7467 20.16 11.5129C18.4739 9.86885 16.3442 9 14.0001 9C11.656 9 9.52627 9.86885 7.84011 11.5129C6.57465 12.7467 6.00274 13.9798 5.98191 14.0296C5.95134 14.0967 5.93555 14.1692 5.93555 14.2426C5.93555 14.316 5.95134 14.3885 5.98191 14.4555C6.00543 14.5073 6.57465 15.7379 7.84011 16.9717C9.52627 18.615 11.656 19.4839 14.0001 19.4839C16.3442 19.4839 18.4739 18.615 20.16 16.9717C21.4255 15.7379 21.9947 14.5073 22.0182 14.4555C22.0488 14.3885 22.0646 14.316 22.0646 14.2426C22.0646 14.1692 22.0488 14.0967 22.0182 14.0296ZM14.0001 16.8629C13.4684 16.8629 12.9487 16.7092 12.5066 16.4212C12.0645 16.1332 11.72 15.7239 11.5165 15.2449C11.3131 14.766 11.2598 14.239 11.3635 13.7306C11.4673 13.2222 11.7233 12.7552 12.0992 12.3886C12.4752 12.0221 12.9542 11.7725 13.4756 11.6713C13.9971 11.5702 14.5376 11.6221 15.0288 11.8205C15.52 12.0189 15.9398 12.3548 16.2352 12.7858C16.5306 13.2168 16.6882 13.7236 16.6882 14.2419C16.6882 14.9371 16.405 15.6037 15.9009 16.0952C15.3968 16.5868 14.713 16.8629 14.0001 16.8629Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.0808,
    cy: 14.2421,
    rx: 4.27419,
    ry: 4.14661,
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84704 8.98267L14.2152 14.1439M14.2152 14.1439L20.7503 19.4405M14.2152 14.1439L20.1532 9.33126M14.2152 14.1439L7.25 19.7891",
    stroke: "#D32F2F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeOmissionWarning);
export default __webpack_public_path__ + "static/media/Type=OmissionWarning.e76d47e5f47e60a3c90569b03ab90d1d.svg";
export { ForwardRef as ReactComponent };